import { render, staticRenderFns } from "./conferee.vue?vue&type=template&id=004c81c9&scoped=true&"
import script from "./conferee.vue?vue&type=script&lang=js&"
export * from "./conferee.vue?vue&type=script&lang=js&"
import style0 from "./conferee.vue?vue&type=style&index=0&id=004c81c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c81c9",
  null
  
)

export default component.exports